import { Typography } from 'omakase';
import { makeSigninLinkIncludingSearch } from 'components/sign-in/Signin';
import Anchor from 'components/Anchor';
import BallPulse from '@tock/shared/components/BallPulse';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  isAuthenticated: boolean;
  isError: boolean;
  isLoading: boolean;
  location: {
    pathname: string;
    search: string;
  };
}

export default class SearchLoading extends BaseComponent<Props> {
  render() {
    const { isAuthenticated, isError, isLoading, location } = this.props;

    return (
      <div className="SearchModal-body">
        {isLoading && (
          <div className="SearchModal-bodyLoading">
            <BallPulse data-testid="SearchLoadingBallPulse" />
          </div>
        )}

        {!isLoading && isError && (
          <Typography>
            {isAuthenticated ? (
              "Sorry -- your search didn't return any results."
            ) : (
              <>
                Sorry -- your search didn't return any results. If you think you reached this page
                in error, try{' '}
                <Anchor href={makeSigninLinkIncludingSearch('login', location as Location)}>
                  logging in
                </Anchor>
                .
              </>
            )}
          </Typography>
        )}
      </div>
    );
  }
}
